import application from 'application/application';

const controller = 'DefaultAccountInfoController';

application.filter('cpfCnpj', () => value => {
	if (!value) return '';

	const clean = String(value)
		.toUpperCase()
		.replace(/[^A-Z0-9]/g, '');

	if (/^\d{11}$/.test(clean)) {
		return clean.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
	}

	if (/^[A-Z0-9]{12}\d{2}$/.test(clean)) {
		return clean.replace(
			/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/,
			'$1.$2.$3/$4-$5'
		);
	}

	return value;
});

application.controller(controller, [
	'$rootScope',
	'$scope',
	'$http',
	'$state',
	'$stateParams',
	'API',
	'helper',
	'notification',
	'authentication',
	(
		$rootScope,
		$scope,
		$http,
		$state,
		$stateParams,
		API,
		helper,
		notification,
		authentication
	) => {
		/*********************/

		$scope.personDetail = {};

		$scope.printing = false;

		$scope.inputs = [
			'idUF',
			'idMunicipio',
			'endereco',
			'numeroEndereco',
			'bairro',
			'complemento'
		];

		$scope.inputsIds = [
			'detailsEditableState',
			'detailsEditableAdressCity',
			'detailsEditableAdress',
			'inputUpdateClientUserNumber',
			'detailsEditableComplementNeighborhood',
			'detailsEditableComplement'
		];

		$scope.newOab = {
			ativo: true,
			id: '',
			idTipoOAB: 0,
			idUF: 0,
			numero: ''
		};

		$scope.invalidCep = false;

		$scope.loadingCep = false;

		$scope.validSaveCep = false;

		$scope.contributorLogged = localStorage.getItem('__simulatedAccess__');

		$scope.addressDisabled = true;

		$scope.updatePersonImage = function(person) {
			if (person && person.foto && person.foto.url)
				person.foto.url = person.foto.url.replace(
					/^data\:image\/\w+\;base64\,(.*)/,
					'$1'
				);
			else
				return notification.danger('Ocorreu um erro ao transformar a imagem.');

			$http({
				...helper.http(API.peoplePic, 'photo'),
				method: 'POST',
				data: {
					itens: [
						{
							foto: person.foto.url,
							extensao: person.foto.format
						}
					]
				},
				messageOverride: {
					success(response, notify) {
						notify.success('Foto do perfil editada!');
					}
				}
			})
				.then(response => {
					localStorage.setItem(
						'__authenticationUserImage__',
						response.data.itens[0].foto
					);

					$rootScope.userImage.avatar = `data:image/png;charset=utf-8;base64, ${response.data.itens[0].foto}`;
				})

				.finally(() => {
					$('.modal').modal('hide');
					$state.go($state.current, {}, { reload: true });
				});
		};

		const inputType = () => {
			$scope.inputType1 = 'password';
			$scope.inputType2 = 'password';
			$scope.inputType3 = 'password';
		};

		inputType();

		$scope.showPassword = num => {
			$scope[`inputType${num}`] =
				$scope[`inputType${num}`] === 'password' ? 'text' : 'password';
		};

		const minCharacters = /(^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).{8,}$)/;
		const minMedia = /(^[0-9a-zA-Z~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<]{9,})/;
		const minForte = /(^[0-9a-zA-Z~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<]{12,})/;

		$scope.passwordStrength = (senha, confirmacao) => {
			if (senha === undefined) return false;

			if (senha.match(minCharacters.source)) {
				$scope.strength = 'fraca';

				if (senha.match(minForte.source)) {
					$scope.strength = 'forte';
				} else if (senha.match(minMedia.source)) {
					$scope.strength = 'média';
				}
			} else {
				$scope.strength = 'inválida';
			}

			if (confirmacao != undefined) $scope.comparePassword(senha, confirmacao);
		};

		$scope.checkField = senha => {
			if (senha === undefined) $scope.strength = null;
		};

		$scope.comparePassword = (confirmacao, senha) => {
			$scope.samePassword =
				$scope.strength === 'inválida' ? false : senha === confirmacao;

			if (confirmacao === undefined) $scope.samePassword = null;
		};

		$scope.cleanImage = function() {
			$http({
				...helper.http(API.peoplePic, 'DELETE'),
				method: 'DELETE',
				params: {
					fotoId: $scope.user.fotoID
				},
				messageOverride: {
					success(response, notify) {
						notify.success('Foto do perfil removida!');
					}
				}
			})
				.then(() => {
					localStorage.removeItem('__authenticationUserImage__');

					$rootScope.userImage.avatar = false;
				})

				.finally(() => {
					setTimeout(() => {
						$state.go($state.current, {}, { reload: true });
					}, 200);
				});
		};

		$scope.cleanImageConfirm = () => $('#modalDeleteImage').modal('show');

		/*********************/

		$scope.user = {};

		$scope.userEmail = {};

		$scope.userClone = {};

		$scope.userLoading = true;

		$scope.currentTab = 'dados-do-perfil';

		/**********************************************************************/

		$scope.alterTab = tab => {
			$scope.currentTab = tab;

			const now = new Date();
			const tabInfo = {
				tab: tab,
				moment: now
			};

			localStorage.setItem('__hasTabMemoryInfo__', JSON.stringify(tabInfo));
		};

		$scope.readCurrentTabFromLocalStorage = defaultValue => {
			const timeLimit = new Date(new Date().getTime() - 300000); // Coloca um valor de 5 minutos atrás, que é o limite de informação que ele tolera para tentar atualizar
			const hasTabMemory = localStorage.getItem('__hasTabMemoryInfo__');

			if (hasTabMemory) {
				const localStorageItem = JSON.parse(hasTabMemory);
				const { tab, moment } = localStorageItem;

				if (new Date(moment).getTime() - new Date(timeLimit).getTime() > 0) {
					$scope.currentTab = tab;

					return;
				}
			}

			$scope.currentTab = defaultValue;
		};

		$scope.readCurrentTabFromLocalStorage('dados-do-perfil');

		/**********************************************************************/

		const getPersonTypeByDocument = document => {
			const digits = (document || '').toString().replace(/\D/g, '');

			return digits.length > 11 ? -2 : -1;
		};

		$scope.getCustomerPersonType = customer => {
			const normalizedPersonType = Number(customer && customer.idTipoPessoa);

			if (normalizedPersonType === -1 || normalizedPersonType === -2)
				return normalizedPersonType;

			return getPersonTypeByDocument(customer && customer.documento);
		};

		$scope.getCustomerLabelName = customer =>
			$scope.getCustomerPersonType(customer) == -2
				? 'Raz\u00e3o social'
				: 'Nome';

		$scope.getCustomerLabelPersonalNumber = customer =>
			$scope.getCustomerPersonType(customer) == -2 ? 'CNPJ' : 'CPF';

		/**********************************************************************/

		setTimeout(() => {
			$http({
				...helper.http(API.usersCustomers, 'GET'),
				params: {
					...helper.httpFields([
						'id',
						'emailUsuario',
						'idPessoa',
						'ativoUsuario',
						'pessoa.idTipoPessoa',
						'pessoa.id',
						'pessoa.nome',
						'pessoa.cpfcnpj',
						'pessoa.idSexo',
						'pessoa.nomeSexo',
						'pessoa.dataNascimentoAbertura',
						'pessoa.fone1',
						'pessoa.fone2',
						'pessoa.email',
						'pessoa.fotoId',
						'pessoa.foto',
						'dadosOAB.id',
						'dadosOAB.ativo',
						'dadosOAB.numero',
						'dadosOAB.idUF',
						'dadosOAB.nomeUF',
						'dadosOAB.idTipoOAB',
						'dadosOAB.nomeTipoOAB',
						'pessoa.bairro'
					]),
					IDs: authentication.getUserData('idUsuarioCliente')
				}
			})
				.then(response => {
					const itens =
						response && response.data && Array.isArray(response.data.itens)
							? response.data.itens
							: [];
					const userData = itens.length ? itens[0] : null;

					if (userData) {
						$scope.user = convertDataUser(userData);
						$scope.userName = $scope.user.nome;

						$scope.emailUsuario = userData.emailUsuario || $scope.user.email;
						$scope.userEmail.emailAtual = $scope.emailUsuario;
						$scope.userEmail.idUsuarioCliente = $scope.user.id;
					} else {
						$scope.user = convertDataUser();
						$scope.emailUsuario = '';
						$scope.userEmail.emailAtual = '';
						$scope.userEmail.idUsuarioCliente = '';
					}

					$scope.userClone = $.extend(true, {}, $scope.user);
				})

				.finally(() => ($scope.userLoading = false));
		}, 100);

		/**********************************************************************/

		$scope.updateUserInfo = userInfo => {
			$scope.printing = true;

			delete userInfo.ufOAB;

			userInfo.cpfcnpj = $scope.customer.documento;
			$http({
				...helper.http(API.usersCustomers, 'PUT'),
				data: {
					itens: [convertDataUserToAPI(userInfo)]
				},
				messageOverride: {
					success(response, notify) {
						notify.success('Dados do perfil editados!');
					}
				}
			})
				.then(response => {
					$scope.user = convertDataUser(response.data.itens[0]);

					$scope.userClone = $.extend(true, {}, $scope.user);

					$scope.user = $scope.userClone;
					$('#mUpdateUserInfo').modal('hide');
				})
				.finally(() => {
					$scope.printing = false;
				});
		};

		/**********************************************************************/

		$scope.genders = helper.responseStore();

		$scope.recordGenders = responseStore => {
			$http({
				...helper.http(API.genders, 'GET'),
				params: {
					...helper.httpFields(['id', 'nome']),
					registrosPorPagina: -1
				}
			})
				.then(response =>
					responseStore.setItems(convertDataGenders(response.data.itens))
				)

				.finally(() => responseStore.setReady(true));
		};

		/**********************************************************************/

		$scope.OABTypes = helper.responseStore();

		$scope.recordOABTypes = responseStore => {
			$http({
				...helper.http(API.OABTypes, 'GET'),
				params: {
					...helper.httpFields(['id', 'nome']),
					registrosPorPagina: -1
				}
			})
				.then(response => {
					responseStore.setItems([
						{
							id: 0,
							nome: 'Selecione'
						},
						...response.data.itens
					]);
				})

				.finally(() => responseStore.setReady(true));
		};

		/**********************************************************************/

		$scope.updateUserPassword = data => {
			$scope.printing = true;

			if (!$scope.samePassword) return false;

			$http({
				...helper.http(API.usersCustomers, 'ChangePassword'),
				method: 'PUT',
				data: {
					itens: [data]
				},
				messageOverride: {
					success(response, notify) {
						notify.success('Senha editada!');
						$('#modalUpdateUserPassword').modal('hide');
					},
					error(response, notify) {
						const mensagem = response.data.status.erros[0].mensagem;

						if (mensagem == 'A senha atual é inválida.')
							$scope.currentPassword = 'Senha inválida';

						notify.danger(mensagem);
					}
				}
			})
				.then(() => {
					$scope.strength = null;
					$scope.samePassword = null;
					inputType();
					Object.keys(data).forEach(key => delete data[key]);
				})
				.finally(() => {
					$scope.printing = false;
				});
		};

		$scope.statusCurrentPassword = () => ($scope.currentPassword = null);

		/**********************************************************************/

		$scope.updateUserEmail = data => {
			$scope.printing = true;

			$http({
				...helper.http(API.usersCustomers, 'ChangeEmail'),
				method: 'PUT',
				data: {
					itens: [data]
				},
				messageOverride: {
					success(response, notify) {
						notify.success('Email editado!');
					}
				}
			})
				.then(() => {
					Object.keys(data).forEach(key => delete data[key]);
					$('#modalUpdateUserEmail').modal('hide');
					setTimeout(() => {
						window.location.reload();
					}, 500);
					$scope.printing = false;
				})
				.catch(() => {
					$scope.printing = false;
				});
		};

		/**********************************************************************/

		$scope.customer = {};

		$scope.customerClone = {};

		$scope.customerLoading = true;

		$http({
			...helper.http(API.customers, 'GET'),
			params: {
				...helper.httpFields([
					'id',
					'pessoaCliente.idTipoPessoa',
					'pessoaCliente.id',
					'pessoaCliente.nome',
					'pessoaCliente.CPFCNPJ',
					'pessoaCliente.cep',
					'pessoaCliente.logradouro',
					'pessoaCliente.numeroEndereco',
					'pessoaCliente.complementoEndereco',
					'pessoaCliente.idMunicipio',
					'pessoaCliente.idUFMunicipio',
					'pessoaCliente.nomeMunicipio',
					'pessoaCliente.nomeUF',
					'pessoaCliente.siglaUF',
					'pessoaCliente.fone1',
					'possuiGrupo',
					'pessoaCliente.bairro'
				]),
				IDs: authentication.getUserData('idCliente')
			}
		})
			.then(response => {
				if (response.data.itens)
					$scope.customer = convertDataCustomer(response.data.itens[0]);

				$scope.customerClone = $.extend(true, {}, $scope.customer);
			})

			.finally(() => ($scope.customerLoading = false));

		$scope.updateCustomer = customer => {
			if ($scope.loadingCep || $scope.printing) return false;

			$scope.printing = true;

			const { email } = JSON.parse(
				localStorage.getItem('__authenticationUserData__')
			);
			const data = convertDataCustomerToAPI(customer);

			data.pessoaCliente.email = email;

			$http({
				...helper.http(API.customers, 'PUT'),
				data: {
					itens: [data]
				},
				messageOverride: {
					success(response, notify) {
						notify.success('Contratante editado!');
					}
				}
			})
				.then(response => {
					$scope.customer = convertDataCustomer(response.data.itens[0]);

					$scope.customer.cidade = $scope.customerClone.cidade;

					$scope.customer.nomeMunicipio = $scope.customerClone.cidade;

					$scope.customer.siglaUF = $scope.customerClone.siglaUF;

					$scope.customerClone = $.extend(true, {}, $scope.customer);

					$scope.customer = {};

					$('#mUpdateContractorInfo').modal('hide');
				})
				.finally(() => {
					$scope.printing = false;
				});
		};

		/**********************************************************************/

		$scope.disableAccount = () => {
			notification.alert({
				title: 'Desativar conta',
				body:
					'Tem certeza que deseja desativar sua conta? Apenas o administrador pode reverter esta ação.',
				buttons: [
					{
						label: 'Cancelar',
						fn: () => $('.modal').modal('hide')
					},
					{
						label: 'Sim, desativar',
						style: 'danger',
						fn: () => {
							$http({
								...helper.http(API.disableUsersCustomers, 'PUT'),
								data: {
									itens: [$scope.user]
								}
							}).then(() => {
								$scope.user.ativo = false;

								$('.modal').modal('hide');

								/** @TODO: Efetuar logout. */
							});
						}
					}
				]
			});
		};

		/**********************************************************************/

		$scope.cities = helper.responseStore();

		$scope.recordCities = (responseStore, uf, localidade) => {
			$http({
				...helper.http(API.cities, 'GET'),
				params: {
					...helper.httpFields(['id', 'nome', 'idUF']),
					idUF: uf,
					ativo: true,
					registrosPorPagina: -1
				}
			})
				.then(response => {
					responseStore.setItems(response.data.itens);

					if ($scope.customer.idMunicipio) {
						$scope.customerClone.cidade = $scope.cities.items.find(
							i => i.id === $scope.customer.idMunicipio
						).nome;
					}

					!localidade && validateCityValue($scope.customer);
				})

				.finally(() => {
					responseStore.setReady(true);

					if (localidade) {
						let value = $scope.cities.items.find(i => i.nome == localidade);

						$scope.customer.idMunicipio = value.id;

						$scope.customerClone.cidade = $scope.cities.items.find(
							i => i.id === $scope.customer.idMunicipio
						).nome;

						$('select[name="cidade"]').val(
							'input',
							value && `number:${value.id}`
						);
					}
				});
		};

		$scope.openModal = (modal, cepParams) => {
			$scope.getCep(cepParams);

			$scope.customer = {};
			$scope.customer = helper.cloneSimpleObject($scope.customerClone);
			$scope.customerCopy = $.extend(true, {}, $scope.customerClone);

			if (!$scope.federativeUnits.getItems().length)
				$scope.recordFederativeUnits($scope.federativeUnits);

			if ($scope.customer.cep) {
				$scope.validationCep($scope.customer.cep);
				$scope.getCep('init');
			}

			const el = $(modal);

			setTimeout(() => {
				el.modal && el.modal('show');
			}, 150);
		};

		/**********************************************************************/

		/**********************************************************************/
		$scope.validFocus = formId => {
			const formUsuario = document.querySelector('#' + formId);

			formUsuario.addEventListener('submit', event => {
				event.preventDefault();

				let data = Object.fromEntries(new FormData(event.target).entries());

				let inputName = Object.keys(data).reverse();

				inputName.forEach(element => {
					let dataInput = document.getElementsByName(element);

					if (dataInput[0].value == '') {
						document.getElementById(dataInput[0].id).focus();
					}
				});
			});
		};
		/**********************************************************************/

		/**********************************************************************/
		$scope.focusInput = idInput => {
			setTimeout(() => {
				document.getElementById(idInput).focus();
			}, 500);
		};
		/**********************************************************************/

		/**********************************************************************/

		$scope.handlerCities = idUF =>
			$scope.cities.getItems().filter(value => value.idUF == idUF);

		/**********************************************************************/

		$scope.federativeUnits = helper.responseStore();

		$scope.recordFederativeUnits = (responseStore, localidade, user) => {
			$http({
				...helper.http(API.federativeUnits, 'GET'),
				params: {
					...helper.httpFields(['id', 'sigla', 'nome']),
					ativo: true,
					registrosPorPagina: -1
				}
			})
				.then(response => {
					responseStore.setItems([
						{ id: 0, nome: ' Selecione', sigla: ' Selecione' },
						...response.data.itens
					]);

					if (!user) {
						if ($scope.customer.idMunicipio && !localidade) {
							$scope.recordCities($scope.cities, $scope.customer.idUF);
						} else {
							$scope.recordCities(
								$scope.cities,
								$scope.customer.idUF,
								localidade
							);
						}
					}
				})

				.finally(() => responseStore.setReady(true));
		};

		if (!$scope.federativeUnits.getItems().length)
			$scope.recordFederativeUnits($scope.federativeUnits, null, true);

		/**********************************************************************/

		$scope.showContractButtom = true;
		$scope.checkContract = () => {
			let hasOab = false;
			let hasAdvise = false;

			const mainStorage =
				JSON.parse(localStorage.getItem('_MAIN_STORAGE_')) || {};

			let contract = mainStorage.contracts || [];

			contract.forEach(element => {
				element.contratosAderidos.forEach(aderidos => {
					if (aderidos.convenioOAB) hasOab = true;
					else hasAdvise = true;
				});

				element.contratosCliente.forEach(aderidos => {
					if (aderidos.convenioOAB) hasOab = true;
					else hasAdvise = true;
				});
			});

			const validosAderidos = contract[0].contratosAderidos
				.filter(contract => !contract.convenioOAB)
				.some(
					item =>
						item.idSituacaoContrato == -3 ||
						item.idSituacaoContrato == -6 ||
						item.idSituacaoContrato == -1
				);

			const validosClientes = contract[0].contratosCliente
				.filter(contract => !contract.convenioOAB)
				.some(
					item =>
						item.idSituacaoContrato == -3 ||
						item.idSituacaoContrato == -6 ||
						item.idSituacaoContrato == -1
				);

			if ((hasOab && !hasAdvise) || (!validosAderidos && !validosClientes))
				$scope.showContractButtom = false;
		};

		$scope.checkContract();

		/**********************************************************************/

		$scope.foo = () => {
			//
		};

		/**********************************************************************/

		function convertDataUser(user) {
			let treatedUser = {
				id: '',
				idPessoa: '',
				nome: '',
				idGenero: '',
				nomeGenero: '',
				dataNascimento: '',
				telefone: '',
				dadosOAB: [],
				email: '',
				foto: '',
				fotoID: '',
				idTipoPessoa: ''
			};

			if (!user) return treatedUser;

			const userPerson = user.pessoa || {};
			const userOabs = Array.isArray(user.dadosOAB) ? user.dadosOAB : [];
			const federativeUnits =
				($scope.federativeUnits &&
					typeof $scope.federativeUnits.getItems === 'function' &&
					$scope.federativeUnits.getItems()) ||
				($scope.federativeUnits && $scope.federativeUnits.items) ||
				[];

			treatedUser.id = user.id;
			treatedUser.idPessoa = userPerson.id;
			treatedUser.nome = userPerson.nome;
			treatedUser.idGenero = userPerson.idSexo;
			treatedUser.nomeGenero = userPerson.nomeSexo;
			treatedUser.dataNascimento = userPerson.dataNascimentoAbertura;
			treatedUser.telefone = userPerson.fone1 || userPerson.fone2;
			treatedUser.email = userPerson.email;
			treatedUser.foto = userPerson.foto;
			treatedUser.fotoID = userPerson.fotoID || userPerson.fotoId;
			treatedUser.idTipoPessoa = userPerson.idTipoPessoa;

			userOabs.forEach(oab => {
				if (!oab || oab.ativo === false) return;

				const federativeUnit = federativeUnits.find(uf => uf.id == oab.idUF);

				treatedUser.dadosOAB.push({
					numeroOAB: oab.numero,
					idOAB: oab.id,
					idUFOAB: oab.idUF,
					ufOAB: oab.nomeUF,
					siglaUfOab: federativeUnit ? federativeUnit.sigla : oab.nomeUF,
					idTipoOAB: oab.idTipoOAB,
					nomeUFOAB: oab.nomeUF,
					nomeTipoOAB: oab.nomeTipoOAB
				});
			});

			// if (index != null) {
			// 	treatedUser.idOAB = user.dadosOAB[index].id;
			// 	treatedUser.numeroOAB = user.dadosOAB[index].numero;
			// 	treatedUser.idUFOAB = user.dadosOAB[index].idUF;
			// 	treatedUser.ufOAB = user.dadosOAB[index].nomeUF;
			// 	treatedUser.idTipoOAB = user.dadosOAB[index].idTipoOAB;
			// 	treatedUser.nomeUFOAB = user.dadosOAB[index].nomeUF;
			// 	treatedUser.nomeTipoOAB = user.dadosOAB[index].nomeTipoOAB;
			// }

			return treatedUser;
		}

		/**********************************************************************/

		function convertDataUserToAPI(treatedUser) {
			let user = {
				id: 0,
				pessoa: {
					id: 0,
					idSexo: 0,
					dataNascimentoAbertura: '',
					fone1: '',
					email: '',
					cpfcnpj: ''
				},
				dadosOAB: []
			};

			if (!treatedUser) return user;

			treatedUser.dadosOAB.length &&
				treatedUser.dadosOAB.forEach(oab => {
					user.dadosOAB.push({
						id: oab.idOAB ? oab.idOAB : '',
						numero: oab.numeroOAB,
						idUF: oab.idUFOAB ? oab.idUFOAB : oab.idUF,
						UF: oab.idUFOAB ? oab.idUFOAB : oab.idUF,
						idTipoOAB: oab.idTipoOAB,
						ativo: oab.ativo == false ? false : true
					});
				});

			user.id = treatedUser.id;
			user.pessoa.id = treatedUser.idPessoa;
			user.pessoa.nome = treatedUser.nome;
			user.pessoa.idSexo = treatedUser.idGenero;
			user.pessoa.dataNascimentoAbertura = treatedUser.dataNascimento;
			user.pessoa.fone1 = treatedUser.telefone;
			user.pessoa.email = treatedUser.email;
			user.pessoa.cpfcnpj = treatedUser.cpfcnpj;
			// user.dadosOAB[0].id = treatedUser.idOAB;
			// user.dadosOAB[0].numero = treatedUser.numeroOAB;
			// user.dadosOAB[0].idUF = treatedUser.idUFOAB;
			// user.dadosOAB[0].nomeUF = treatedUser.ufOAB;
			// user.dadosOAB[0].idTipoOAB = treatedUser.idTipoOAB;

			return user;
		}

		/**********************************************************************/

		function convertDataGenders(genders) {
			let treatedGenders = [];

			genders.forEach(gender => {
				let treatedGender = {
					id: gender.id,
					genero: gender.nome
				};

				treatedGenders.push(treatedGender);
			});

			return treatedGenders;
		}

		/**********************************************************************/

		function convertDataCustomer(customer) {
			let treatedCustomer = {
				id: 0,
				possuiGrupo: null,
				idTipoPessoa: '',
				idPessoa: 0,
				nome: '',
				documento: '',
				cep: '',
				endereco: '',
				numeroEndereco: '',
				complemento: '',
				idMunicipio: 0,
				idUF: 0,
				nomeMunicipio: '',
				siglaUF: '',
				telefone: '',
				bairro: ''
			};

			if (!customer) return treatedCustomer;

			treatedCustomer.id = customer.id;
			treatedCustomer.possuiGrupo = customer.possuiGrupo;

			if (customer.pessoaCliente) {
				treatedCustomer.idTipoPessoa = customer.pessoaCliente.idTipoPessoa;
				treatedCustomer.idPessoa = customer.pessoaCliente.id;
				treatedCustomer.nome = customer.pessoaCliente.nome;
				treatedCustomer.documento =
					customer.pessoaCliente.cpfcnpj || customer.pessoaCliente.CPFCNPJ;
				treatedCustomer.cep = customer.pessoaCliente.cep;
				treatedCustomer.endereco = customer.pessoaCliente.logradouro;
				treatedCustomer.numeroEndereco = customer.pessoaCliente.numeroEndereco;
				treatedCustomer.complemento =
					customer.pessoaCliente.complementoEndereco;
				treatedCustomer.idMunicipio = customer.pessoaCliente.idMunicipio;
				treatedCustomer.idUF = customer.pessoaCliente.idUFMunicipio;
				treatedCustomer.nomeMunicipio = customer.pessoaCliente.nomeMunicipio;
				treatedCustomer.siglaUF = customer.pessoaCliente.siglaUF;
				treatedCustomer.telefone = customer.pessoaCliente.fone1;
				treatedCustomer.bairro = customer.pessoaCliente.bairro;
			}

			return treatedCustomer;
		}

		/**********************************************************************/

		function convertDataCustomerToAPI(treatedCustomer) {
			let customer = {
				id: 0,
				possuiGrupo: null,
				pessoaCliente: {
					id: 0,
					nome: '',
					cpfcnpj: '',
					cep: '',
					logradouro: '',
					numeroEndereco: '',
					complementoEndereco: '',
					idMunicipio: 0,
					idUFMunicipio: 0,
					fone1: '',
					dataNascimentoAbertura: '',
					fone1: '',
					email: '',
					bairro: ''
				}
			};

			if (!treatedCustomer) return customer;

			customer.id = treatedCustomer.id;
			customer.possuiGrupo = treatedCustomer.possuiGrupo;
			customer.pessoaCliente.id = treatedCustomer.idPessoa;
			customer.pessoaCliente.nome = treatedCustomer.nome;
			customer.pessoaCliente.cpfcnpj = treatedCustomer.documento;
			customer.pessoaCliente.cep = treatedCustomer.cep;
			customer.pessoaCliente.logradouro = treatedCustomer.endereco;
			customer.pessoaCliente.numeroEndereco = treatedCustomer.numeroEndereco;
			customer.pessoaCliente.complementoEndereco = treatedCustomer.complemento;
			customer.pessoaCliente.idMunicipio = treatedCustomer.idMunicipio;
			customer.pessoaCliente.idUFMunicipio = treatedCustomer.idUF;
			customer.pessoaCliente.fone1 = treatedCustomer.telefone;
			customer.pessoaCliente.email = treatedCustomer.email;
			customer.pessoaCliente.bairro = treatedCustomer.bairro;

			return customer;
		}

		/**********************************************************************/

		function validateCityValue(customer) {
			const value = $scope.cities
				.getItems()
				.find(city => city.idUF === customer.idUF);

			$('select[name="cidade"]').val('input', value && `number:${value.id}`);

			return !value;
		}

		/**********************************************************************/

		$('#mUpdateContractorInfo').on('hidden.bs.modal', () => {
			if ($scope.customer.idUF != $scope.customerClone.idUF)
				$scope.recordCities($scope.cities, $scope.customerCopy.idUF);

			$scope.customer = $.extend(true, {}, $scope.customerClone);

			$('#invalid-cep').css('display', 'none');
			$scope.resetValidAndInvalid('#detailsEditableAdressPostalCode');

			$scope.invalidCep = false;

			$scope.loadingCep = false;

			$scope.validSaveCep = false;

			$scope.oldCep = '';

			$scope.inputsIds.forEach(i => {
				$scope.resetValidAndInvalid(`#${i}`);
			});

			$('#invalid-detailsEditableState').css('display', 'none');
			$('#invalid-detailsEditableAdressCity').css('display', 'none');
			$('#invalid-detailsEditableComplementNeighborhood').css(
				'display',
				'none'
			);
			$('#invalid-detailsEditableAdress').css('display', 'none');

			helper.defer(() => $scope.$apply());

			$scope.$resetFormValidation('nUpdateCustomer')();
		});

		/**********************************************************************/

		$('#mUpdateUserInfo').on('hidden.bs.modal', () => {
			$scope.user = $.extend(true, {}, $scope.userClone);

			helper.defer(() => $scope.$apply());

			$scope.$resetFormValidation('nUpdateUserInfo')();
		});

		/**********************************************************************/

		$scope.modalOpen = modal => {
			if (!$scope.genders.getItems().length)
				$scope.recordGenders($scope.genders);

			if (!$scope.OABTypes.getItems().length)
				$scope.recordOABTypes($scope.OABTypes);

			setTimeout(() => {
				$(modal).modal('show');
			}, 300);
		};

		/**********************************************************************/

		$scope.validationCep = cep => {
			cep == '' && ($scope.customerCopy.invalidCep = false);

			const testeCep = cep
				? cep
						.replace(/\D/g, '')
						.replace(/(\d{5})(\d)/, '$1-$2')
						.replace(/(-\d{3})\d+?$/, '$1')
				: '';

			$scope.customer.cep = cep == 'init' ? cep : '';

			document.getElementById(
				'detailsEditableAdressPostalCode'
			).value = testeCep;

			if (
				!($scope.customerCopy && $scope.customerCopy.invalidCep) &&
				(!testeCep || testeCep.length === 9)
			)
				$('#detailsEditableAdressPostalCode').removeClass('is-invalid');
			else if (
				testeCep.length < 9 ||
				($scope.customerCopy && $scope.customerCopy.invalidCep)
			)
				$('#detailsEditableAdressPostalCode').addClass('is-invalid');

			$scope.customer.cep = testeCep;
		};

		/**********************************************************************/

		$scope.getCep = (cep, refresh) => {
			if ($scope.loadingCep) {
				if (!cep && $scope.oldCep == 'init') cep = $scope.customerCopy.cep;
				else cep = $scope.oldCep;

				$scope.validationCep(cep);
			}
			if (
				!refresh &&
				$scope.oldCep === 'init' &&
				$scope.customerCopy.cep === cep.replace('-', '')
			)
				return false;

			if (!$scope.customer.cep && cep === 'init') return false;

			if (!refresh && $scope.oldCep == 'init' && cep == $scope.customerCopy.cep)
				return false;

			if (cep !== 'init' && cep === $scope.oldCep) return false;
			$scope.oldCep = cep;

			$('#invalid-cep').css('display', 'none');
			$scope.resetValidAndInvalid('#detailsEditableAdressPostalCode');

			$scope.invalidCep = false;
			$scope.loadingCep = false;
			$scope.validSaveCep = true;
			$scope.customerCopy && ($scope.customerCopy.invalidCep = false);
			$scope.customerCopy && ($scope.customerCopy.divergent = false);

			let c = cep;

			if (cep && cep.length > 4) {
				c = cep.replace('-', '');
			}

			let reg = /[^0-9]/g;

			if (c == 'init' && !$scope.customer.cep) return false;

			if (
				(!reg.test(c) &&
					c &&
					c.length == 8 &&
					Boolean(parseInt(c) || c == '00000000')) ||
				c == 'init' ||
				refresh
			) {
				$scope.loadingCep = true;
				$scope.loadingCepCity = true;
				$scope.addressDisabled = true;

				$http({
					...helper.http(API.queryCep, 'GET'),
					params: {
						cep: cep != 'init' ? cep : $scope.customer.cep
					}
				})
					.then(async ({ data }) => {
						$('#detailsEditableComplementNeighborhood').attr(
							'disabled',
							'disabled'
						);

						$('#detailsEditableAdress').attr('disabled', 'disabled');

						if (!data.logradouro)
							$('#detailsEditableAdress').removeAttr('disabled', 'disabled');

						if (!data.bairro)
							$('#detailsEditableComplementNeighborhood').removeAttr(
								'disabled',
								'disabled'
							);

						if (data.cep) {
							if (cep == 'init' && !refresh) {
								//Verificando divergencias entre os ceps

								$scope.customer.idUF &&
									($scope.customer.siglaUf = $scope.federativeUnits.items.find(
										uf => uf.id == $scope.customer.idUF
									).sigla);

								if ($scope.customer.siglaUf != data.uf) {
									$scope.validCep('#detailsEditableState', false);

									$scope.enableErrorCep(
										'#invalid-detailsEditableState',
										'Estado',
										true
									);
									$scope.customerCopy.divergent = true;
								}

								if (
									(!Boolean($scope.customer.cidade) &&
										data.localidade.length) ||
									$scope.customer.cidade != data.localidade
								) {
									$scope.validCep('#detailsEditableAdressCity', false);

									$scope.enableErrorCep(
										'#invalid-detailsEditableAdressCity',
										'Cidade',
										true
									);
									$scope.customerCopy.divergent = true;
								}

								if (
									data.logradouro != '' &&
									$scope.customer.endereco != data.logradouro
								) {
									$scope.validCep('#detailsEditableAdress', false);
									$scope.enableErrorCep(
										'#invalid-detailsEditableAdress',
										'Endereço',
										true
									);
									$scope.customerCopy.divergent = true;
								}

								if (data.logradouro == '' && $scope.customer.endereco != '') {
									$('#detailsEditableAdress').removeAttr(
										'disabled',
										'disabled'
									);
								}

								if (
									data.bairro != '' &&
									$scope.customer.bairro != data.bairro
								) {
									$scope.validCep(
										'#detailsEditableComplementNeighborhood',
										false
									);
									$scope.enableErrorCep(
										'#invalid-detailsEditableComplementNeighborhood',
										'Bairro',
										true
									);
									$scope.customerCopy.divergent = true;
								}

								if (data.bairro == '' && $scope.customer.bairro != '') {
									$('#detailsEditableComplementNeighborhood').removeAttr(
										'disabled',
										'disabled'
									);
								}

								Boolean($scope.customerCopy.divergent) &&
									($scope.invalidCep = true);
								$scope.validSaveCep = $scope.customerCopy.divergent
									? true
									: false;
								$scope.setFocusCep(false);
							} else {
								//Autocomplete dos campos

								$scope.inputsIds.forEach((i, indexOf) => {
									$(`#invalid-${i}`).css('display', 'none');
									if (indexOf >= 2) {
										$(`#${i}`).removeClass('is-valid');
										$(`#${i}`).removeClass('is-invalid');
									}
								});

								if (data.uf) {
									$scope.idUf = $scope.federativeUnits.items.find(
										uf => uf.sigla == data.uf
									).id;

									$scope.customer.idUF = $scope.idUf;
									$scope.customer.cidade = data.localidade;

									await $scope.recordFederativeUnits(
										$scope.federativeUnits,
										data.localidade
									);

									$scope.enableErrorCep(
										'#invalid-detailsEditableState',
										'',
										false,
										true
									);
									$scope.resetValidAndInvalid('#detailsEditableState');

									$scope.enableErrorCep(
										'#invalid-detailsEditableAdressCity',
										'',
										false,
										true
									);
									$scope.resetValidAndInvalid('#detailsEditableAdressCity');
								}

								if (data.logradouro && data.logradouro.length > 0) {
									$('#detailsEditableAdress').attr('disabled', 'disabled');

									$scope.customer.endereco = data.logradouro;
									$scope.enableErrorCep('#invalid-log', '', false, true);
									$scope.resetValidAndInvalid('#detailsEditableAdress');
								} else {
									$scope.customer.endereco = '';
									$('#detailsEditableAdress').removeAttr('disabled');
								}

								if (data.bairro && data.bairro.length > 0) {
									$('#detailsEditableComplementNeighborhood').attr(
										'disabled',
										'disabled'
									);

									$scope.customer.bairro = data.bairro;
									$scope.enableErrorCep('#invalid-bai', '', false, true);
									$scope.resetValidAndInvalid(
										'#detailsEditableComplementNeighborhood'
									);
								} else {
									$scope.customer.bairro = '';
									$('#detailsEditableComplementNeighborhood').removeAttr(
										'disabled'
									);
								}

								$scope.invalidCep = false;
								$scope.customerCopy.divergent = false;
								$scope.customerCopy.invalidCep = false;

								if (data.logradouro == '') {
									$('#detailsEditableAdress').removeAttr('disabled');
								}

								if (data.bairro == '') {
									$('#detailsEditableComplementNeighborhood').removeAttr(
										'disabled'
									);
								}

								$scope.validSaveCep = false;
								$scope.setFocusCep(false);
							}
							$scope.loadingCep = false;
						}
					})
					.catch(err => {
						if (err && err.status == 500) {
							$scope.addressDisabled = false;

							$scope.recordCities($scope.cities, $scope.customer.idUF);

							$('#invalid-cep').css('display', 'flex');

							const invalidCepMessage =
								err &&
								err.data &&
								err.data.status &&
								err.data.status.erros &&
								err.data.status.erros.length > 0 &&
								err.data.status.erros[0].mensagem
									? ' ' + err.data.status.erros[0].mensagem
									: ' Não foi possivel realizar a solicitação no momento devido a uma falha inesperada.';

							$('#invalid-cep').text(invalidCepMessage);
						} else {
							//Cep invalido
							$scope.inputs.forEach((i, indexOf) => {
								if (indexOf >= 2) {
									$scope.customer[i] = '';
								}
							});

							$scope.validCep('#detailsEditableAdressPostalCode', false);
							document
								.getElementById('detailsEditableAdressPostalCode')
								.focus();

							if (Boolean($scope.customer.idUF)) {
								$scope.enableErrorCep(
									'#invalid-detailsEditableState',
									'Estado',
									true
								);
								$scope.validCep('#detailsEditableState', false);
							}

							if (Boolean($scope.customer.idMunicipio)) {
								$scope.validCep('#detailsEditableAdressCity', false);
								$scope.enableErrorCep(
									'#invalid-detailsEditableAdressCity',
									'Cidade',
									true
								);
							}

							$('#invalid-detailsEditableAdress').css('display', 'none');
							$('#invalid-detailsEditableComplementNeighborhood').css(
								'display',
								'none'
							);

							$('#invalid-cep').css('display', 'flex');

							const invalidCepMessage =
								err &&
								err.data &&
								err.data.status &&
								err.data.status.erros &&
								err.data.status.erros.length > 0 &&
								err.data.status.erros[0].mensagem
									? ' ' + err.data.status.erros[0].mensagem
									: ' Digite um cep válido';

							$('#invalid-cep').text(invalidCepMessage);

							$('#ContributorsCep').removeClass('is-valid');
							$('#ContributorsCep').addClass('is-invalid');

							$scope.inputsIds.forEach((i, indexOf) => {
								if (indexOf >= 2) {
									$(`#${i}`).removeAttr('disabled');

									$(`#${i}`).removeClass('is-valid');
									$(`#${i}`).removeClass('is-invalid');
								}
							});
							$scope.invalidCep = false;
							$scope.customerCopy.divergent = true;
							$scope.customerCopy.invalidCep = true;
							$scope.validSaveCep = true;
							$scope.loadingCep = false;
						}
					})
					.finally(() => ($scope.loadingCep = false));
			} else if (cep == '') {
				$('#detailsEditableAdressPostalCode').addClass('is-invalid');
				document.getElementById('detailsEditableAdressPostalCode').focus();

				$scope.inputs.forEach((i, indexOf) => {
					if (indexOf == 0) {
						$scope.customer.idUF = null;
					} else {
						$scope.customer[i] = '';
					}
				});

				$scope.inputsIds.forEach((i, indexOf) => {
					$scope.resetValidAndInvalid(`#${i}`);
					if (indexOf >= 2) {
						$(`#${i}`).removeAttr('disabled');
					}
				});

				$('#invalid-detailsEditableState').css('display', 'none');
				$('#invalid-detailsEditableAdressCity').css('display', 'none');
				$('#invalid-detailsEditableComplementNeighborhood').css(
					'display',
					'none'
				);
				$('#invalid-detailsEditableAdress').css('display', 'none');

				$scope.validSaveCep = false;
				$scope.loadingCep = false;
			}
		};

		/**********************************************************************/

		$scope.resetValidAndInvalid = id => {
			$(id).removeClass('is-invalid');
			$(id).removeClass('is-valid');
		};

		/**********************************************************************/

		$scope.enableErrorCep = (id, message, updateCep, valid) => {
			if (!valid) {
				$(id).css('display', 'flex');
				$(id).text(message + ' divergente do CEP');

				updateCep && ($scope.invalidCep = true);
			} else {
				$(id).css('display', 'none');
			}
		};

		/**********************************************************************/

		$scope.validCep = (id, valid) => {
			if (!valid) {
				$(id).removeClass('is-valid');
				$(id).addClass('is-invalid');
			} else {
				$(id).removeClass('is-invalid');
				$(id).addClass('is-valid');
			}
		};

		/**********************************************************************/

		$scope.setFocusCep = () => {
			if ($scope.customer.endereco == '') {
				document.getElementById('detailsEditableAdress').focus();
			} else if ($scope.customer.numeroEndereco == '') {
				document.getElementById('inputUpdateClientUserNumber').focus();
			} else if ($scope.customer.complementoEndereco == '') {
				document.getElementById('detailsEditableComplement').focus();
			} else if ($scope.customer.bairro == '') {
				document
					.getElementById('detailsEditableComplementNeighborhood')
					.focus();
			}
		};

		/**********************************************************************/

		$scope.preventDefaultEnter = event => {
			event.preventDefault();
		};

		$(function() {
			$('#detailsEditableAdressPostalCode').on({
				cut: e => {
					if ($scope.loadingCep) e.preventDefault();
				},
				paste: e => {
					if ($scope.loadingCep) e.preventDefault();
				},
				copy: e => {
					if ($scope.loadingCep) e.preventDefault();
				}
			});
		});

		/**********************************************************************/

		$scope.isValidCep = () => {
			return Boolean($scope.validSaveCep || $scope.loadingCep);
		};

		/**********************************************************************/

		$scope.errorAddOab = input => {
			if (input == 'All') {
				notification.danger('Cadastro não pode ficar vazio!');
			} else if (input == 'Numero') {
				if (!$scope.newOab.numero) {
					notification.danger('O campo N° da OAB é obrigatório!');
				} else {
					notification.danger('Já existe um cadastro com este N° da OAB!');
				}
			} else if (input == 'UF') {
				notification.danger('O campo UF da OAB é obrigatório!');
			} else if (input == 'OAB') {
				notification.danger('O campo Tipo da OAB é obrigatório!');
			}

			return;
		};

		/**********************************************************************/

		$scope.handlerAddOab = () => {
			function getTypeOab(code) {
				switch (code) {
					case 0:
						return 'Selecione';
					case -1:
						return 'Principal';
					case -2:
						return 'Suplementar';
					case -3:
						return 'Estagiário';

					default:
						break;
				}
			}

			let error = {
				all: false,
				num: false,
				typeOab: false,
				uf: false
			};

			const hasDuplicateOabByState =
				Boolean($scope.newOab.numero && $scope.newOab.idUF) &&
				$scope.user.dadosOAB.some(
					oab =>
						oab.ativo != false &&
						oab.numeroOAB == $scope.newOab.numero &&
						(oab.idUFOAB ? oab.idUFOAB : oab.idUF) == $scope.newOab.idUF
				);

			// Error
			if (
				!$scope.newOab.idUF &&
				(hasDuplicateOabByState || !$scope.newOab.numero) &&
				!$scope.newOab.idTipoOAB
			) {
				$scope.errorAddOab('All');
				error.all = true;
			}

			if (!error.all && (hasDuplicateOabByState || !$scope.newOab.numero)) {
				$scope.errorAddOab('Numero');
				error.num = true;
			}

			if (!error.all && !$scope.newOab.idUF) {
				$scope.errorAddOab('UF');
				error.uf = true;
			}

			if (!error.all && !$scope.newOab.idTipoOAB) {
				$scope.errorAddOab('OAB');
				error.typeOab = true;
			}

			if (error.all || error.num || error.typeOab || error.uf) return;

			$scope.newOab.siglaUfOab = $scope.federativeUnits.items.find(
				uf => uf.id == $scope.newOab.idUF
			).sigla;
			$scope.newOab.nomeUFOAB = $scope.federativeUnits.items.find(
				uf => uf.id == $scope.newOab.idUF
			).nome;
			$scope.newOab.numeroOAB = $scope.newOab.numero;
			$scope.newOab.nomeTipoOAB = getTypeOab($scope.newOab.idTipoOAB);

			$scope.user.dadosOAB.push(helper.cloneSimpleObject($scope.newOab));

			$scope.newOab = {
				ativo: true,
				id: '',
				idTipoOAB: 0,
				idUF: 0,
				numero: ''
			};

			$('select[name="idUFOAB"]').val('');
			$('select[name="idTipoOAB"]').val('');

			setTimeout(() => {
				$('select[name="idUFOAB"]').triggerHandler('change');
				$('select[name="idTipoOAB"]').triggerHandler('change');
			}, 300);
		};

		/**********************************************************************/

		$scope.filterApenasAtivo = () => {
			if ($scope.user.dadosOAB && $scope.user.dadosOAB.length)
				return $scope.user.dadosOAB.filter(oab => oab.ativo != false);
		};

		/**********************************************************************/

		$scope.handlerDeleteOab = (oab, action) => {
			if (action == 'pre_delete') oab.preDelete = true;
			else if (action == 'cancel_delete') oab.preDelete = false;
			else if (action == 'delete') {
				oab.preDelete = false;
				oab.ativo = false;
				$scope.user.dadosOAB;
			}
		};

		/**********************************************************************/

		$scope.permissions = helper.responseStore();
		$scope.clientUsers = helper.responseStore();
		$scope.clientUserKeywords = helper.responseStore();
		$scope.keyWordsVariations = helper.responseStore();
		$scope.diaries = [];

		$scope.hasPublications = false;
		$scope.hasProcesses = false;

		$scope.getPermissions = () => {
			$scope.permissions.setReady(false);

			$http({
				...helper.http(API.permissions, 'GET'),
				params: {
					...helper.httpFields([
						'nomeServico',
						'idFuncionalidade',
						'idServico'
					]),
					registrosPorPagina: -1,
					ativo: true
				}
			})
				.then(response => {
					response.data.itens.forEach(item => {
						if (item.idServico === -1) $scope.hasPublications = true;
						if (item.idServico === -2) $scope.hasProcesses = true;
					});
					$scope.permissions.setItems(response.data.itens);
				})

				.finally(() => $scope.permissions.setReady(true));
		};
		$scope.getPermissions();

		$scope.getClientUser = () => {
			$scope.clientUsers.setReady(false);
			$http({
				...helper.http(API.usersCustomers, 'GET'),
				params: {
					...helper.httpFields(['pessoa.nome']),
					registrosPorPagina: -1,
					expansao: 'pessoa',
					ativoUsuario: true,
					idCliente: authentication.getUserData('idCliente')
				}
			})
				.then(response => {
					const itens = response.data.itens;

					$scope.clientUsers.setItems(itens);
					$scope.clientUsers.tooltip = itens
						.map(item => item.pessoa.nome)
						.join(', ');
				})
				.finally(() => $scope.clientUsers.setReady(true));
		};
		$scope.getClientUser();

		$scope.creditPlan;
		$scope.creditPlanLoading = true;

		$scope.recordCreditPlan = () => {
			$scope.creditPlanLoading = true;

			$http({
				...helper.http(API.userClientFunctionalities, 'GET'),
				params: {
					idFuncionalidade: -32
				}
			})
				.then(response => {
					const item = response.data.itens[0];

					$scope.creditPlan = item.qtdTotalContratado ? true : false;

					$scope.processesPermissions = item.qtdTotalContratado || 0;

					$scope.qtdUtilizadaContrato = item.qtdUtilizadaContrato;
				})

				.finally(() => ($scope.creditPlanLoading = false));
		};
		$scope.recordCreditPlan();

		$scope.recordClientUserDiaries = researches => {
			let keywords = [];
			let situations = [-3, -4];

			researches.listaPesqPublicUsuarioCliente.map(k =>
				keywords.length === 0 &&
				!situations.some(s => s === k.palavraChave.idSituacaoPalavraChave)
					? keywords.push(k)
					: !keywords.some(y => y.idPalavraChave === k.idPalavraChave) &&
					  !situations.some(s => s === k.palavraChave.idSituacaoPalavraChave)
					? keywords.push(k)
					: ''
			);

			keywords.forEach(item => {
				let ativo = 0,
					inativo = 0;

				researches.listaPesqPublicUsuarioCliente.forEach(pesq => {
					if (pesq.idPalavraChave == item.idPalavraChave)
						if (pesq.flAtivo) ativo += 1;
						else inativo += 1;
				});
				if (ativo == 0 && inativo != 0) item.flAtivo = false;
				else item.flAtivo = true;
			});

			$scope.clientUserKeywords.setItems(keywords);
		};

		$scope.recordKeywords = () => {
			$scope.clientUserKeywords.setReady(false);
			$http({
				...helper.http(
					API.searchPublicationUserClient,
					'palavraChaveConsultar'
				),
				method: 'GET',
				params: {
					...helper.httpFields(['*']),
					idTipoPalavraChave: -1,
					idSituacaoPalavraChave: -1,
					registrosPorPagina: 50,
					paginaAtual: 1
				}
			})
				.then(response => {
					if (response.data.itens) {
						$scope.clientUserKeywords.setItems(response.data.itens);
						$scope.recordDiaries($scope.clientUserKeywords);
					}
				})
				.finally(() => $scope.clientUserKeywords.setReady(true));
		};

		$scope.recordKeywords();

		$scope.recordDiaries = response => {
			$http({
				...helper.http(API.searchPublicationUserClient, 'diarioConsultar'),
				method: 'GET',
				params: {
					...helper.httpFields(['*']),
					idCliente: JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idCliente,
					idUsuarioCliente: JSON.parse(
						localStorage.getItem('__authenticationUserData__')
					).idUsuarioCliente,
					idPalavraChave: response.items.map(value => value.id).join(',')
				}
			}).then(response => {
				if (response.data.itens) {
					$scope.diaries = response.data.itens;
				}
			});
		};
	}
]);

export default controller;
